import React from "react";
import ourProcessImg from "../../assets/images/ourProcessImg.png";

type Steps = {
  title: string;
  text: string;
};

const steps: Steps[] = [
  {
    title: "Make An appointment",
    text: "Schedule your session easily online or via call and take the first step toward improving your mental well-being.",
  },
  {
    title: "Begin Your Consultation",
    text: "Meet with our expert for a personalized session to discuss your needs and create a tailored plan for success.",
  },
  {
    title: "Get The Positive Result",
    text: "Experience growth, clarity, and balance as we work together to help you achieve your mental well-being goals.",
  },
];

const OurProcess = () => {
  return (
    <div className="py-6 w-full px-4 sm:px-12 jost-regular sm:py-20 mx-4 sm:mx-12 flex flex-col gap-5 sm:gap-10 justify-center items-center">
      <div className="flex flex-col items-center gap-4">
        <h3 className="jost-regular text-xl sm:text-2xl py-4 uppercase">
          OUR Process
        </h3>
        <h1 className="jost-regular !font-[500] text-3xl text-center sm:text-5xl max-w-xl">
          Sustainable
          <span className="italic mr-3 tracking-[-3px] font-eiko-thin text-primary">
            Wellness
          </span>
          Process Is <br />
          What We Do
        </h1>
      </div>

      <div className="mx-4 sm:mx-12 w-full flex flex-col md:flex-row gap-5 sm:gap-10 justify-center items-center">
        <div className="w-full overflow-hidden rounded-xl">
          <img
            src={ourProcessImg}
            className="hover:scale-105 transition-all duration-300"
            alt=""
          />
        </div>
        <div className="flex flex-col gap-4 w-full">
          {steps.map((item, index) => (
            <div className="flex flex-col gap-2" key={item.title}>
              <div className="uppercase text-primary border-b pb-2 mb-4">
                Step {index + 1}
              </div>
              <h3 className="text-xl sm:text-3xl">{item.title}</h3>
              <p className="opacity-50 mt-4">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurProcess;
